import './edosushi/style';
import FormStructure from './edosushi/form_structure';

export default FormStructure;